import { checkFail } from '../core/core.ts';
import type { Quantity } from './quantity.ts';
import { Scalar } from './scalar.ts';
import { type Unit, Factory } from './unit.ts';
import { Vector } from './vector.ts';

export function buildMeasure<Q extends Quantity>(units: Unit<Q>, ...raw: [number]): Scalar<Q>;
export function buildMeasure<Q extends Quantity>(
  units: Unit<Q>,
  ...raw: [number, number]
): Vector<Q, 2>;
export function buildMeasure<Q extends Quantity>(
  units: Unit<Q>,
  ...raw: [number, number, number]
): Vector<Q, 3>;
export function buildMeasure<Q extends Quantity>(
  units: Unit<Q>,
  ...raw: [number, number, number, number]
): Vector<Q, 4>;
export function buildMeasure<Q extends Quantity>(
  units: Unit<Q>,
  ...raw: number[]
): Scalar<Q> | Vector<Q, 2> | Vector<Q, 3> | Vector<Q, 4> {
  if (raw.length === 1) {
    return Scalar.buildFromRaw(units, raw[0]);
  } else {
    if (raw.length > 4) {
      checkFail(`Vector length ${raw.length} must be less than or equal to 4.`);
    }
    return Vector.buildFromRaw(
      units,
      raw as [number, number] | [number, number, number] | [number, number, number, number],
    ) as Vector<Q, 2> | Vector<Q, 3> | Vector<Q, 4>;
  }
}

export function initializeBuild() {
  Factory.build = buildMeasure;
}
